export var UPDATE_ACTIVE_SESSION_START = 'UPDATE_ACTIVE_SESSION_START';
export var UPDATE_ACTIVE_SESSION_SUCCESS = 'UPDATE_ACTIVE_SESSION_SUCCESS';
export var UPDATE_ACTIVE_SESSION_ERROR = 'UPDATE_ACTIVE_SESSION_ERROR';
export var CLEAR_INPUT = 'CLEAR_INPUT';
export var CHANGE_LIST = 'CHANGE_LIST';
export var LOAD_MORE_MESSAGES_START = 'LOAD_MORE_MESSAGES_START';
export var LOAD_MORE_MESSAGES_SUCCESS = 'LOAD_MORE_MESSAGES_SUCCESS';
export var LOAD_MORE_SESSION_START = 'LOAD_MORE_SESSION_START';
export var LOAD_MORE_SESSION_SUCCESS = 'LOAD_MORE_SESSION_SUCCESS';
